import { H5, Image } from "../../../../AbstractElements";
import { Link } from "react-router-dom";
import { SellingProductDetailsProp } from "../../../../Type/DashboardType";
import { dynamicImage } from "../../../../Service/DynamicImage";

export const SellingProductDetails = ({ imageSrc, productName }: SellingProductDetailsProp) => {
  return (
    <td>
      <div className="d-flex align-items-center">
        <div className="flex-shrink-0">
          <Image className="img-50" src={dynamicImage(`dashboard-2/selling/${imageSrc}`)} alt="" />
        </div>
        <div className="flex-grow-1 ms-2">
          <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
            <H5>{productName}</H5>
          </Link>
        </div>
      </div>
    </td>
  );
};
